import { Injectable } from '@angular/core';
import { environment } from '@env';

@Injectable({
  providedIn: 'root'
})
export class EndpointsService {
  endpointUrl: string = environment.config.endpoints.API;
  createSession: string = `${this.endpointUrl}/api/Session`;
  validateSession: string = `${this.endpointUrl}/api/Session/tireSpecSessionSearch`;
  getQuotes: string = `${this.endpointUrl}/api/tire-quotes`;
  processOcr: string = `${this.endpointUrl}/api/Sidewall/ocr`;
  getTireBrands: string = `${this.endpointUrl}/api/Sidewall/tire-brands`;
  getTireLines: string = `${this.endpointUrl}/api/Sidewall/tire-lines`;
  requestContact: string = `${this.endpointUrl}/api/TireQuoteCommunication/request-contact`;
  forwardQuote: string = `${this.endpointUrl}/api/TireQuoteCommunication/forward-quote`;
}
